module.exports = __webpack_public_path__ + "static/img/detail_near.2b9d831e.svg";